import { render, staticRenderFns } from "./SourceConfigEditor.vue?vue&type=template&id=008cded5&scoped=true&"
import script from "./SourceConfigEditor.vue?vue&type=script&lang=js&"
export * from "./SourceConfigEditor.vue?vue&type=script&lang=js&"
import style0 from "./SourceConfigEditor.vue?vue&type=style&index=0&id=008cded5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008cded5",
  null
  
)

export default component.exports